// extracted by mini-css-extract-plugin
module.exports = {"skip-to-main-content":"SkipToMainContent_skip-to-main-content__Jqj61"};